import { observer } from "mobx-react-lite";
import useFlyTo, { InitiatorType } from "../hooks/useFlyTo";
import IGeoCoordinate from "../interfaces/IGeoCoordinate";
import DetailsPanel, { IDetailsPanelProps } from "./DetailsPanel";

function DetailsPanelWithFlyTo({ coordinates, ...props }: IDetailsPanelWithFlyToProps) {
    useFlyTo(coordinates, InitiatorType.Details);

    return (
        <DetailsPanel {...props} />
    );
}

export default observer(DetailsPanelWithFlyTo);

export interface IDetailsPanelWithFlyToProps extends IDetailsPanelProps {
    coordinates: IGeoCoordinate;
}